module.exports = __webpack_public_path__ + "static/media/bat3.17661341.png";